/* Alpaheat – galerie produit : swipe sur la grande photo + compteur (mobile) */
(function () {
  if (window.__alpFix) return; window.__alpFix = true;
  function bind() {
    document.querySelectorAll('[data-alp-product]').forEach(function (root) {
      if (root.dataset.swipe) return; root.dataset.swipe = '1';
      var box = root.querySelector('.alp-pdp__main');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-alp-thumb]'));
      if (!box || thumbs.length < 2) return;
      var strip = thumbs[0].parentElement;
      var count = document.createElement('span');
      count.className = 'alp-pdp__count';
      box.appendChild(count);
      var current = function () { var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); return i < 0 ? 0 : i; };
      var update = function () { count.textContent = (current() + 1) + ' / ' + thumbs.length; };
      var center = function (t) {
        var sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect();
        strip.scrollTo({ left: strip.scrollLeft + (tr.left - sr.left) - (strip.clientWidth - tr.width) / 2, behavior: 'smooth' });
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { setTimeout(function () { update(); center(t); }, 0); }); });
      update();
      var sx = null, sy = null;
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var n = (current() + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        thumbs[n].click();
      }, { passive: true });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('[data-alp-product]').forEach(function (r) { delete r.dataset.swipe; }); bind(); });
})();
